import { render, staticRenderFns } from "./ModalManifestacao.vue?vue&type=template&id=0c649cb4"
import script from "./ModalManifestacao.vue?vue&type=script&lang=js"
export * from "./ModalManifestacao.vue?vue&type=script&lang=js"
import style0 from "./ModalManifestacao.vue?vue&type=style&index=0&id=0c649cb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports